// Canonical phone-number normalization, shared by csv.ts (upload/manual-add
// validation) and data.ts (stored-phone lookups, opt-out checks). Previously
// duplicated as three separate, behaviorally-identical copies — consolidated
// here so a `global_opt_outs` lookup key can never drift from what the rest
// of the app considers "the same number".
export function normalizePhoneNumber(value: string, allowTestNumbers = false): string | null {
  const digits = value.replace(/\D/g, "");
  if (allowTestNumbers && digits.length === 10 && digits.startsWith("999")) return `+1${digits}`;
  if (allowTestNumbers && digits.length === 11 && digits.startsWith("1999")) return `+${digits}`;
  if (digits.length === 10 && digits.startsWith("999")) return null;
  if (digits.length === 11 && digits.startsWith("1999")) return null;
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return null;
}
